<div class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Cashbook (cashbook.hu) beállítások</ion-card-title>
      <ion-card-subtitle>
        A számlák (és a storno/módosító bizonylatok) cashbook.hu felé küldésének kapcsolója és API kulcsa.
        A kulcs biztonsági okból maszkolva jelenik meg; üresen hagyva a korábbi marad érvényben.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>

      <ion-item>
        <ion-label>Cashbook beküldés bekapcsolva</ion-label>
        <ion-toggle slot="end" [(ngModel)]="settings.enabled"></ion-toggle>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">API végpont (URL)</ion-label>
        <ion-input [(ngModel)]="settings.url" placeholder="https://cashbook.hu/api/v3/document/pool/osa"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">
          API kulcs (Bearer token)
          <span *ngIf="hasApiKey" style="color:#888"> (jelenleg beállítva: {{ apiKeyMask }})</span>
        </ion-label>
        <ion-input type="password" [(ngModel)]="settings.api_key"
          placeholder="Hagyd üresen, ha nem változtatod"></ion-input>
      </ion-item>

      <div style="display:flex; gap:8px; margin-top:16px; flex-wrap:wrap">
        <ion-button color="success" (click)="saveSettings()" [disabled]="saving || loading">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          Mentés
        </ion-button>
        <ion-button fill="clear" color="medium" (click)="loadSettings()" [disabled]="loading">Újratöltés</ion-button>
      </div>

      <ion-note color="medium" style="display:block; margin-top:12px; font-size:12px">
        Kikapcsolva egyetlen bizonylat sem kerül beküldésre a cashbook felé. A NAV beküldés ettől független,
        külön kapcsolón állítható (NAV adatkapcsolat).
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
